import { createDomain } from 'effector';

import { type Answers } from 'types/zod/answers';
import { type GiftTrustItem } from 'types/zod/gift-trust-item';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('pages/gift-trust');

type QInstanceId = QuestionnaireInstance['questionnaire_instance_id'];

const $$giftTrustPage = {
    $qInstances: domain.store<QuestionnaireInstance[]>([]),
    $tabs: domain.store<
        Record<
            QInstanceId,
            {
                answers: Answers | null;
                giftTrustItems: GiftTrustItem[];
                isSigned: boolean;
                qInstance: QuestionnaireInstance;
                isPayed: boolean;
                name: string;
                jobs: { qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id']; job_id?: number }[];
            }
        >
    >({}),

    createGiftTrustButtonClicked: domain.event(),
    addGiftButtonClicked: domain.event<QInstanceId>(),
    deleteGiftButtonClicked: domain.event<{ qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id'] }>(),
    generateGiftButtonClicked: domain.event<{ qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id'] }>(),
    openGiftItemModal: domain.event<QInstanceId>(),
    resumeButtonClicked: domain.event<QInstanceId>(),
    deleteButtonClicked: domain.event<QInstanceId>(),
    downloadAllButtonClicked: domain.event<QInstanceId>(),
    documentsButtonClicked: domain.event<QInstanceId>(),
    updateButtonClicked: domain.event<QInstanceId>(),
    markAsSignedClicked: domain.event<QInstanceId>(),
};

export default $$giftTrustPage;
